import React from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

export const DatePickerLocalizationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <LocalizationProvider dateAdapter={AdapterLuxon}>{children}</LocalizationProvider>;
};
